import { Box, Divider, Typography } from "@mui/material"
import type { FC } from "react"

import type { WarehouseShelving } from "@/graphql/codegen/graphql"

interface PalletDestinationDisplayProps {
  destination?: WarehouseShelving | null
}
const fontSize = "96px"
export const PalletDestinationDisplay: FC<PalletDestinationDisplayProps> = ({ destination }) => {
  if (!destination) {
    return (
      <Box className='text-center'>
        <Typography variant='h2' className='font-bold text-gray-500' sx={{ fontSize }}>
          None assigned
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          Storage location
        </Typography>
      </Box>
    )
  }

  return (
    <Box className='flex items-center justify-between'>
      <Box className='flex flex-1 flex-col items-center' data-testid='pallet-destination-aisle'>
        <Typography variant='h2' className='font-bold text-gray-900' sx={{ fontSize }}>
          {destination.aisleCode}
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          Aisle
        </Typography>
      </Box>

      <Divider orientation='vertical' flexItem className='border-gray-300' />

      <Box className='flex flex-1 flex-col items-center' data-testid='pallet-destination-shelf'>
        <Typography variant='h2' className='font-bold text-gray-900' sx={{ fontSize }}>
          {destination.sectionCode}
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          Shelf
        </Typography>
      </Box>

      <Divider orientation='vertical' flexItem className='border-gray-300' />

      <Box className='flex flex-1 flex-col items-center' data-testid='pallet-destination-bin'>
        <Typography variant='h2' className='font-bold text-gray-900' sx={{ fontSize }}>
          {destination.binNumber}
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          Bin
        </Typography>
      </Box>
    </Box>
  )
}
